import React from 'react'
import { Stack, SimpleTabs } from '@/components/lib'

import useStore from '../../../store'
import useTitle from '../../../hooks/useTitle'
import Dashboards from './Dashboards'
import Explore from './Explore'
import Export from './Export'
import Integrations from './Integrations'

export default function Results () {
  const { trial } = useStore()
  useTitle('Results', trial)
  return (
    <Stack gap={5}>
      <SimpleTabs
        tabs={[
          { title: 'Dashboards', content: <Dashboards /> },
          { title: 'Explore', content: <Explore /> },
          { title: 'Export', content: <Export /> },
          { title: 'Integrations', content: <Integrations /> }
        ]}
      />
    </Stack>
  )
}
